<template>
    <kgr-profile-part
        v-if="!isEmpty"
        :heading="$t('Beziehungen')"
    >
        <template #content>
            <div v-if="spouseRelationsMembers.length !== 0">
                <h3
                    v-t="'Ehepartner'"
                    class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText"
                ></h3>
                <kgr-member-relation
                    v-for="spouse in spouseRelationsMembers"
                    :key="spouse.id"
                    :member="spouse"
                />
                <hr class="kgr-separator kgr-separator--light" />
            </div>

            <div v-if="childRelationsMembers.length !== 0">
                <h3
                    v-t="'Kinder'"
                    class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText"
                ></h3>
                <kgr-member-relation
                    v-for="child in childRelationsMembers"
                    :key="child.id"
                    :member="child"
                />
                <hr class="kgr-separator kgr-separator--light" />
            </div>

            <div v-if="parentRelationsMembers.length !== 0">
                <h3
                    v-t="'Eltern'"
                    class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText"
                ></h3>
                <kgr-member-relation
                    v-for="parent in parentRelationsMembers"
                    :key="parent.id"
                    :member="parent"
                />
                <hr class="kgr-separator kgr-separator--light" />
            </div>

            <div v-if="siblingRelationsMembers.length !== 0">
                <h3
                    v-t="'Geschwister'"
                    class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText"
                ></h3>
                <kgr-member-relation
                    v-for="sibling in siblingRelationsMembers"
                    :key="sibling.id"
                    :member="sibling"
                />
                <hr class="kgr-separator kgr-separator--light" />
            </div>

            <div v-if="familyRelationsMembers.length !== 0">
                <h3
                    v-t="'Familienmitglieder'"
                    class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText"
                ></h3>
                <kgr-member-relation
                    v-for="familyMember in familyRelationsMembers"
                    :key="familyMember.id"
                    :member="familyMember"
                />
                <hr class="kgr-separator kgr-separator--light" />
            </div>
        </template>
    </kgr-profile-part>
</template>

<script>
import KgrMemberRelation from './MemberRelation';
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-relations',
    components: {
        KgrMemberRelation,
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        parentRelationsMembers() {
            return this.memberShortProfile.relations.parentChildRelations
                .filter(relation => relation.child.id === this.memberShortProfile.id)
                .map(relation => relation.parent)
                .sort(this.compareMembers);
        },
        childRelationsMembers() {
            return this.memberShortProfile.relations.parentChildRelations
                .filter(relation => relation.parent.id === this.memberShortProfile.id)
                .map(relation => relation.child)
                .sort(this.compareMembers);
        },
        spouseRelationsMembers() {
            return this.memberShortProfile.relations.spouseRelations
                .map(relation => relation.member)
                .sort(this.compareMembers);
        },
        siblingRelationsMembers() {
            return this.memberShortProfile.relations.siblingRelations
                .map(relation => relation.member)
                .sort(this.compareMembers);
        },
        familyRelationsMembers() {
            return this.memberShortProfile.relations.familyRelations
                .map(relation => relation.member)
                .sort(this.compareMembers);
        },
        isEmpty() {
            return !(this.parentRelationsMembers.length !== 0
                    || this.childRelationsMembers.length !== 0
                    || this.siblingRelationsMembers.length !== 0
                    || this.spouseRelationsMembers.length !== 0
                    || this.familyRelationsMembers.length !== 0);
        },
    },
    methods: {
        compareMembers(m1, m2) {
            if(m1.contractState.status === 0 && m2.contractState.status !== 0){
                return 1;
            }
            if(m1.contractState.status !== 0 && m2.contractState.status === 0){
                return -1;
            }

            const s1 = m1.firstName + m1.lastName;
            const s2 = m2.firstName + m2.lastName;

            return s1.toLowerCase().localeCompare(s2.toLowerCase());
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
